<template>
  <div class="flex flex-col justify-start">
    <div class="grid items-center grid-cols-2">
      <div class="text-xl font-bold">在线课程</div>
    </div>

    <!-- <div class="flex flex-row pt-5 space-x-5">
            <button @click="" class="text-sm text-red-400"> <span >最新</span></button>
            <button @click="" class="text-sm"> <span >热门</span></button>
        </div> -->

    <div v-if="classInfoArray && classInfoArray.length > 0" class="grid grid-cols-2 mt-3 overflow-visible lg:gap-5 md:gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
      <div v-for="(value, index) in classInfoArray" :key="value.id">
        <ShowClassCardVue :objData="value"></ShowClassCardVue>
      </div>
    </div>
    <div v-else class="flex flex-col items-center justify-center">
      <el-empty description="课程内容为空" image="/img/empty.png" :image-size="44" />
      <el-button type="primary" size="small" @click="refreshWindowLocation">刷新</el-button>
    </div>
    <div class="flex flex-col items-center justify-center pt-5 pb-10">
      <el-pagination
        v-model="currentPage"
        @update:current-page="handleCurrentChange"
        :hide-on-single-page="true"
        :page-size="8"
        size="small"
        background
        layout="prev, pager, next"
        :total="totalPage"
        class="mt-4"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useLoginInfo } from '~/stores/user/loginInfo'
import ShowClassCardVue from './components/ShowClassCard.vue'
import { useClassInfoArray } from '~/stores/livingClass/classInfoArray'

export interface ClassInfoArray {
  id: number
  course_name: string
  course_cover_url: string
  course_introduce: string
  who_can_watch: number
  rank_name: string
  tag_name: string
  course_created_time: string
  watch_count: number
  platform_comment: string
}

//网络请求获取图片,课程名称，课时，类别， id
const classInfoArray = ref<ClassInfoArray[]>([])

const loginInfo = useLoginInfo()
const currentPage = ref(1)
const totalPage = ref(1)

/**
 * 获取分页的数量
 */
const getPageSize = async (totalPage: any) => {
  // 请求的内容
  const obj = {
    url: RequestAPI.GET_CLASS_ARRAY,
    body: {
      page: currentPage.value,
      size: 8,
      platform: loginInfo.platform,
    },
  }

  const { data, status, error } = await postRequired(obj)
  if (data.value && (data.value || data.hasOwnProperty('data'))) {
    totalPage.value = data.value.data.total
    classInfoArray.value = data.value.data.list
    return totalPage
  }
  return totalPage
}

// 在钩子启动的时候执行
onMounted(() => {
  nextTick(() => {
    getPageSize(totalPage)
  })
})

/**
 * 处理 current-page的切换 实现分页的请求
 */
const handleCurrentChange = async (val: number) => {
  console.log(`current page: ${val}`)
  currentPage.value = val
  await getPageSize(totalPage)
}
</script>
